import { get } from 'lodash'
import { COMPANY_INFO } from '../actions/users'

function companyReduers(state = {}, action) {
  switch (action.type) {
    case COMPANY_INFO:
      return { ...state, ...get(action, 'companyInfo', {}) }
    default:
      return state
  }
}

export default companyReduers
